import { Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../cms/block/abstract-cms-block.component';

/**
 * Block content interface
 */
export interface IGiftboxNameInfoContent extends NICmsContentComponent.IData {
    text?: string;
}

/**
 * Component definition
 */
@Component({
    selector: 'giftbox-name-info',
    templateUrl: './giftbox-name-info.html',
    standalone: true,
    imports: [ICmsClientModule]
})
@ICmsComponent<GiftboxNameInfoComponent>({
    id: 'giftbox-name-info',
    block: {
        url: 'giftbox-name-info'
    },
    onDemandOnly: true,
    name: 'Giftbox Name Info',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'text',
            title: 'Text'
        }
    ]
})
export class GiftboxNameInfoComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IGiftboxNameInfoContent;
}
